import React from 'react';

// Module-level so it's shared by the poller and every documents list
let availableDocIds: ReadonlySet<string> = new Set();
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getAvailableDocIds = () => availableDocIds;

/**
 * Records docIds that POST /refresh reported as available documents
 */
export const addAvailableDocIds = (docIds: string[]) => {
  const newIds = docIds.filter((docId) => !availableDocIds.has(docId));
  if (!newIds.length) {
    return;
  }
  availableDocIds = new Set([...availableDocIds, ...newIds]);
  listeners.forEach((listener) => listener());
};

/**
 * @returns The docIds reported as available documents this session
 */
export const useAvailableDocIds = () =>
  React.useSyncExternalStore(subscribe, getAvailableDocIds);
